var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-5"},[_c('titleAgency'),(_vm.render)?_c('filterAgency',{attrs:{"mode":_vm.page}}):_vm._e(),(_vm.render)?_c('tableAgency',{attrs:{"mode":_vm.page}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }